import React, { useEffect, useState } from 'react';
import {
	Button,
	OverlayTrigger,
	Popover
} from 'adp-react-components';
import classnames from 'classnames';
import get from 'lodash/get';
import axios from 'axios';
import moment from 'moment';
import FaEnvelope from 'adp-react-icons/lib/fa/envelope';
import { ConfirmModal } from '../../common/confirmBeforeAction'
import { showErrorModal, useApplicationState } from '../../../utilities/applicationState';
import './preAuthEmail.scss';
import FaCheck from 'adp-react-icons/lib/fa/check-circle';
import FaExclamationCircle from 'adp-react-icons/lib/fa/exclamation-circle';
import FaInfo from 'adp-react-icons/lib/fa/info-circle';

export default function PreAuthEmail({ activeCR }) {
	const [, dispatch] = useApplicationState();
	const [showLastSentModal, setShowLastSentModal] = useState(false);
	const [timeStampData, setTimeStampData] = useState(null);
	const [lastSentEmailTimeStamp, setLastSentEmailTimeStamp] = useState('');
	const [showSuccessMessage, setShowSuccessMessage] = useState(false);
	const [disableEmailButton, setDisableEmailButton] = useState(true);
	const [showErrorMessage, setShowErrorMessage] = useState(false);
	const [showInfoIcon, setShowInfoIcon] = useState(false);

	const id = activeCR.consumerApplicationID;
	const requestNumber = activeCR.requestNumber;
	const cutOffDate = activeCR.cutOffDate;

	const getEmailTimeStampData = async () => {
		try {
			const { data: responseObject } = await axios.get(
				`${import.meta.env.VITE_ROOT_PATH}/api/reminder-email/time-stamp/${id}/${requestNumber}`
			);

			const date = moment(responseObject.lastEmailSent).utc().local().format('MM/DD/YYYY');
			const time = moment(responseObject.lastEmailSent).utc().local().format('hh:mm A');
			setTimeStampData({
				...responseObject,
				date,
				time
			});
			if (responseObject.hasTimeStamp && !responseObject.isSentToday) {
				setDisableEmailButton(false);
				setLastSentEmailTimeStamp(<div>
					<div>
						This action will send out a mass email reminder to all customers who still need to provide
						pre-authorization. The last email was sent
						on {date} at {time}.
					</div>
					<br/>
					<div>Would you still like to send?</div>
				</div>);
			} else if (!responseObject.hasTimeStamp && !responseObject.isSentToday) {
				setDisableEmailButton(false);
			} else if (responseObject.hasTimeStamp && responseObject.isSentToday) {
				setDisableEmailButton(true);
				setShowInfoIcon(true);
			}
		} catch (e) {
			hideModal();
			dispatch(showErrorModal(get(e, 'response.data.message', 'Something went wrong when trying to get last email timestamp. Please try again.')));
		}
	};

	const onClickSendReminderBtn = () => {
		if (timeStampData.hasTimeStamp && !timeStampData.isSentToday) {
			setShowLastSentModal(true);
		} else {
			sendReminderEmail();
		}
	};

	const hideModal = () => {
		setShowLastSentModal(false);
	};

	const sendReminderEmail = async () => {
		try {
			setDisableEmailButton(true);

			await axios.post(
				`${import.meta.env.VITE_ROOT_PATH}/api/reminder-email`, {
					b2bConsumerAppID: id,
					cutOffDate,
					requestNumber
				});
			setShowSuccessMessage(true);
		} catch (e) {
			setShowErrorMessage(true);
		}
	};

	const date = get(timeStampData, 'date', '');
	const time = get(timeStampData, 'time', '');

	const infoTooltip = (
		<Popover id="summary-tooltip">
			<span>
				Only one email can be sent per day. The last email was sent on {date} at {time}
			</span>
		</Popover>
	);

	useEffect(() => {
		getEmailTimeStampData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className="pre-auth-email">
			<div className="pre-auth-email-aside">
			{showInfoIcon && <div className="pre-auth-info-icon">
				<OverlayTrigger
					trigger={["hover", "focus"]}
					placement="top"
					overlay={infoTooltip}>
					<FaInfo/>
				</OverlayTrigger>
				</div>}
			<div className={classnames('pre-auth-email-icon', disableEmailButton && 'pre-auth-disable-email-icon')}>
				<FaEnvelope/> <Button
				disabled={disableEmailButton}
				buttonStyle='link'
				className={'pre-auth-button'}
				onClick={() => {
					onClickSendReminderBtn();
				}}>SEND PREAUTHORIZATION EMAIL </Button>
			</div>
			</div>
			{showLastSentModal && <ConfirmModal
				confirm={true}
				closeModal={hideModal}
				title={'ARE YOU SURE'}
				body={lastSentEmailTimeStamp}
				onClick={sendReminderEmail}
				onCancel={hideModal}
				cancelText={'No'}
				confirmText={'Yes'}
				size={'lg'}
			/>}
			{showSuccessMessage && <div className="pre-auth-success">
			<div className="pre-auth-success-check">
				<FaCheck/>
			</div>
				<div className="pre-auth-success-text">Email successfully sent</div>
			</div>}
			{showErrorMessage && <div className="pre-auth-error-message-container">
				<FaExclamationCircle className="pre-auth-email-failure" />
				<div className="pre-auth-email-error-message">Error occurred, please try again.</div>
			</div>}
		</div>
	);
}
